module.exports = __webpack_public_path__ + "static/media/small-logo-chapter-yellow-white.99d39637.png";